<template>
  <div>
    <img class="login-logo" src="../assets/top.jpg" />
    <div class="login-form">
      <input type="text" class="login-form-uname" placeholder="请输入账号" v-model="loginData.username">
      <input type="password" class="login-form-pwd" placeholder="请输入密码" v-model="loginData.password">
    </div>
    <div class="login-btn">
      <button type="button" class="login-btn-login" @click="doLogin">登录</button>
      <div class="more-btn">
        <!-- <a class="pwd-forget" href>找回密码</a> |  -->
        <a class="register" href="/#/user/register">注册账号</a>
      </div>
    </div>
    <div class="tech">技术支持：四川万识科技有限公司</div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import { Toast } from "mint-ui";
Vue.use(VueResource)
export default {
  name: "Login",
  data: function(){
    return {
      loginData: {
        username: null,
        password: null
      }
    }
  },
  computed: {
    loginEnable: function() {
      return this.loginData.username && this.loginData.password;
    }
  },
  methods: {
    doLogin: function() {
      if (!this.loginEnable) {
        Toast("请输入账号和密码!");
        return;
      }
      this.$http
        .post(this.GLOBAL.serverUrl + "/login", this.loginData, { emulateJSON: true })
        .then(
          function(resp) {
            var resObj = resp.body;
            if (resObj.code == 200) {
              this.$router.push("/index/prod");
            } else if (resObj.code == 500 && resObj.msg) {
              Toast(resObj.msg);
            }
          }
        );
    }
  }
};
</script>

<style scoped>
img.login-logo {
  width: 100%;
}

.login-form {
  text-align: center;
  padding: 0 1rem;
}

.login-form input {
  width: 100%;
  height: 3rem;
  margin-top: 1rem;
  border: none;
  border-bottom: 1px solid #dddddd;
  font-size: 1rem;
  padding: 1.5rem 1rem 0.5rem 3rem;
  box-sizing: border-box;
}

.login-form input.login-form-uname {
  background: url("../assets/tel.png") no-repeat 1rem 1.45rem;
  background-size: 0.8rem 1rem;
}

.login-form input.login-form-pwd {
  background: url("../assets/lock.png") no-repeat 1rem 1.45rem;
  background-size: 0.8rem 1rem;
}

.login-btn {
  padding: 0 1rem;
  margin-top: 3rem;
  text-align: center;
}

.login-btn .login-btn-login {
  background: #006dbc;
  border-radius: 2rem;
  width: 100%;
  height: 2rem;
  border: none;
  color: white;
  font-size: 1rem;
}

.more-btn {
  margin-top: 1rem;
  text-align: center;
}

.more-btn a {
  text-decoration: none;
  height: 1.5rem;
  line-height: 1.5rem;
  display: inline-block;
  margin: 0 0.5rem;
}
.tech{
  text-align: center;
  margin-top: 5rem;
  font-size: 0.9rem;
}
</style>